// Utility to match a concrete path against a pattern list with colon params and optional () suffixes.
// Supports patterns like: /e-gramatas/:slug/pdf or /viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()/contents
// We ignore query/hash and optionally strip a configurable base prefix such as /v2.

export function normalizePath(path: string, basePrefixes: string[] = ["/v2"]) {
  const noQuery = path.split(/[?#]/)[0]
  for (const base of basePrefixes) {
    if (noQuery.startsWith(base + "/")) {
      return noQuery.slice(base.length)
    }
  }
  return noQuery
}

export function pathMatchesPattern(path: string, pattern: string): boolean {
  const curSegs = normalizePath(path).split("/").filter(Boolean)
  const patSegs = pattern.split("/").filter(Boolean)
  if (curSegs.length !== patSegs.length) {
    return false
  }
  for (let i = 0; i < patSegs.length; i++) {
    const p = patSegs[i]
    const c = curSegs[i]
    if (p.startsWith(":")) {
      // Param segment may have trailing () annotation -> strip
      // Accept any non-empty current segment
      if (!c) {
        return false
      }
      continue
    }
    if (p !== c) {
      return false
    }
  }
  return true
}

export function anyPatternMatches(path: string, patterns: string[]): boolean {
  return patterns.some((p) => pathMatchesPattern(path, p))
}
